import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import { IQuickAdd } from "@faire/web-api/indigofair/data/IQuickAdd";

export interface QuickAddProps {
  productToken: string | undefined;
  quickAdd: IQuickAdd | undefined;
  brandToken: string | undefined;
  state: keyof typeof IProduct.State | undefined;
  productName: string | undefined;
  productImage: IImage | undefined;
  // Tracking
  impressionId: string | undefined;
  promotedBy: Array<keyof typeof IProduct.PromotedType> | undefined;
}

export const productTileQuickAddPropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): QuickAddProps => {
  return {
    productToken: productTile.product?.token,
    quickAdd: productTile.quick_add,
    state: productTile.product?.state,
    brandToken: productTile.product?.brand_token,
    impressionId: productTile.product?.impression_id,
    promotedBy: productTile.product?.promoted_by,
    productName: productTile.product?.name,
    productImage: productTile.images?.[0] ?? undefined,
  };
};
